import * as React from "react";
import { PageUrl } from "src/routes/PageUrl";

import {
  ManagementSpecCommonCard,
  ManagementSpecCommonCardStore,
} from "../../ManagementSpecCommon/ManagementSpecCommonCard";

const pageStore = new ManagementSpecCommonCardStore({
  specType: "primary",
  newTitle: "Новая первичная спецификация",
  middleCrumb: { type: "AdminPrimSpecs" },
});

export const ManagementPrimSpecCard: React.FC = () => (
  <ManagementSpecCommonCard
    pageStore={pageStore}
    listUrl={PageUrl.managementPrimSpecs}
    cardUrl={PageUrl.managementPrimSpecCard}
  />
);
